import React from 'react';
import { BaseModal } from './BaseModal';

interface PreferencesInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function PreferencesInfoModal({ isOpen, onClose }: PreferencesInfoModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="OneTrust Preference Center Integration"
    >
      <div className="space-y-6 text-gray-600 dark:text-gray-300">
        <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Automated Data Subject Creation
          </h3>
          <p className="mb-4">
            When you create an account, our system automatically triggers the following process:
          </p>
          <ol className="list-decimal list-inside space-y-2 ml-4">
            <li>A webhook notification is sent to OneTrust</li>
            <li>OneTrust creates a new data subject profile with your information</li>
            <li>A unique magic link is generated for your preference center</li>
            <li>The magic link is securely stored in your profile</li>
          </ol>
        </div>

        <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Seamless Authentication
          </h3>
          <p className="mb-4">
            The magic link system provides a secure, seamless experience:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>No additional login required for the preference center</li>
            <li>Automatic authentication using your unique link</li>
            <li>Direct access to your personalized preferences</li>
            <li>Secure, encrypted connection to OneTrust</li>
          </ul>
        </div>

        <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Real-time Integration
          </h3>
          <p className="mb-4">
            The entire process happens automatically within minutes:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Instant data subject creation</li>
            <li>Immediate magic link generation</li>
            <li>Real-time preference center access</li>
            <li>Synchronized data across platforms</li>
          </ul>
        </div>

        <div className="mt-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg">
          <p className="text-sm text-blue-800 dark:text-blue-200">
            This automated integration ensures you always have secure, authenticated access to manage your privacy preferences
            through OneTrust's enterprise-grade preference center.
          </p>
        </div>
      </div>
    </BaseModal>
  );
}